// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_hk","advertCardPhoto__image":"c-a_hl"};